<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3 card nice-shadow-18">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-6 lg:col-5">
              <div class="">
                <div class="flex align-items-center">
                  <div class="ml-2">
                    <div class="text-2xl text-primary font-bold">
                      {{ item.name }}
                    </div>
                    <div class="text-sm text-500">{{ item.description }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid"></div>
          <div class="col-12 comp-grid">
            <div class="">
              <div class="reset-grid">
                <list-institutionprogrammes-page
                  is-sub-page
                  ref="institutionProgrammesListPage"
                  :limit="30"
                  field-name="institution_programmes.institution_school_id"
                  :field-value="item.institution_school_id"
                  :show-header="true"
                  :show-breadcrumbs="true"
                  :show-footer="true"
                  :paginate="true"
                  v-if="ready"
                >
                </list-institutionprogrammes-page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import listInstitutionprogrammesPage from "../institution_programmes/list.vue";
import { defineAsyncComponent, ref } from "vue";
import { PageMixin } from "../../mixins/page.js";
import { ViewPageMixin } from "../../mixins/viewpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "viewInstitutionschoolsPage",
  components: {
    listInstitutionprogrammesPage,
  },
  mixins: [PageMixin, ViewPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_schools",
    },
    idName: {
      type: String,
      default: "institution_school_id",
    },
    routeName: {
      type: String,
      default: "institution_schoolsview",
    },
    pagePath: {
      type: String,
      default: "institution_schools/view",
    },
    apiPath: {
      type: String,
      default: "institution_schools/view",
    },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Department Details";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["institution_schools/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("institution_schools/setCurrentRecord", value);
      },
    },
  },
  meta() {
    return {
      title: this.pageTitle,
    };
  },
  methods: {
    ...mapActions("institution_schools", ["fetchRecord", "deleteRecord"]),
    getActionMenuModel(data) {
      return [
        {
          label: "Edit",
          to: `/institution_schools/edit/${data.institution_school_id}`,
          icon: "pi pi-pencil",
        },
        {
          label: "Delete",
          command: (event) => {
            this.deleteItem(data.institution_school_id);
          },
          icon: "pi pi-minus-circle",
        },
      ];
    },
  },
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
